import React, { useEffect } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
// import qs from 'query-string';

import { useAuthorization } from './authorization';
import { CartProvider, HelmetProvider, useMenu } from './common';
import { useLanguageChange } from '../i18n';
import { BreakpointsProvider } from '../common/providers';

// const UnderReconstruction = React.lazy(() => import('./reconstruction/components/UnderReconstruction'));
const TopBar = React.lazy(() => import('./common/components/TopBar'));
const BottomBar = React.lazy(() => import('../common/components/BottomBar'));
const Home = React.lazy(() => import('./home/views/Home'));
const Products = React.lazy(() => import('./product/views/Products'));
const Product = React.lazy(() => import('./product/views/Product'));
const Complete = React.lazy(() => import('./order/views/Complete'));
const Recovery = React.lazy(() => import('./authorization/views/Recovery'));
const AboutUs = React.lazy(() => import('./common/views/AboutUs'));
const Refund = React.lazy(() => import('./common/views/Refund'));
const Delivery = React.lazy(() => import('./common/views/Delivery'));
const Privacy = React.lazy(() => import('./common/views/Privacy'));
const NotFound = React.lazy(() => import('./common/views/NotFound'));

const ClientApp = () => {
  useLanguageChange();

  const { identify } = useAuthorization();
  const { menuOpened, triggerMenu } = useMenu();
  const { pathname } = useLocation();

  // const { test } = qs.parse(search);

  useEffect(() => {
    identify();
  // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (menuOpened) {
      triggerMenu();
    }
    // eslint-disable-next-line
  }, [pathname]);

  // if (test !== 'true') {
  //   return <UnderReconstruction />
  // }

  return (
    <CartProvider>
      <HelmetProvider>
        <BreakpointsProvider>
          <Switch>
            <Route exact path="/" component={Home} />
            <Route exact path="/products" component={Products} />
            <Route exact path="/product/:id" component={Product} />
            <Route exact path="/complete" component={Complete} />
            <Route exact path="/recovery/:email/:token" component={Recovery} />

            <Route exact path="/info/about" component={AboutUs} />
            <Route exact path="/info/refund" component={Refund} />
            <Route exact path="/info/delivery" component={Delivery} />
            <Route exact path="/info/privacy" component={Privacy} />

            <Route component={NotFound} />
          </Switch>
        </BreakpointsProvider>
        <TopBar />
        <BottomBar />
      </HelmetProvider>
    </CartProvider>
  );
};

ClientApp.propTypes = {};

export default ClientApp;